<div class="ir-cell-lar4">
  <div class="ir-item-line th-filter-modal">
    <div class="ir-item-cell clickable" [ngClass]="{ disabled: !node }" (click)="createFolder()">
      <span> <i class="material-icons">create_new_folder</i> New folder </span>
    </div>
    <label class="ir-item-cell clickable ir-inputfile" [ngClass]="{ disabled: !node }" for="file">
      <input
        *ngIf="node"
        type="file"
        name="file"
        (click)="clearInput($event)"
        (change)="handleInputChange($event)"
        multiple="true"
        id="file"
      />
      <span> <i class="material-icons">cloud_upload</i> Upload </span>
    </label>
    <div class="ir-item-cell clickable" [ngClass]="{ disabled: !node || !anySelected() }" (click)="openDeleteConfirm()">
      <span> <i class="material-icons">delete</i> Delete </span>
    </div>
  </div>
  <folder-tree
    [nodes]="nodes"
    (toggleOpenNode)="openNode($event)"
    (toggleExpandNode)="expandNode($event)"
    (toggleCloseNode)="closeNode($event)"
  ></folder-tree>
</div>
<div class="ir-cell-lar8" style="height: 100%">
  <file-list
    [node]="node"
    (toggleOpenNode)="openNode($event)"
    (toggleSelectNode)="selectNode($event)"
    (toggleGotoNodeParent)="gotoNodeParent($event)"
    (toggleHandleInputChange)="handleInputChange($event)"
    [query]="query"
  >
  </file-list>
</div>
<confirm
  #deleteConfirm
  (confirmOutput)="deleteNodes()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure you want to delete selected items?'"
  [danger]="true"
></confirm>
